"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Slider", {
    enumerable: true,
    get: function() {
        return Slider;
    }
});
var _themetools = require("@chakra-ui/theme-tools");
var sharedSizeStyle = function(props) {
    return {
        thumb: {
            w: "1rem",
            h: "1rem"
        },
        track: (0, _themetools.orient)({
            orientation: props.orientation,
            horizontal: {
                h: "0.375rem"
            },
            vertical: {
                w: "0.375rem"
            }
        })
    };
};
var Slider = {
    baseStyle: function(param) {
        var isDisabled = param.isDisabled;
        return {
            track: {
                bg: "background-action-active",
                borderRadius: "radii-half",
                _disabled: {
                    bg: "background-container-disabled"
                }
            },
            filledTrack: {
                bg: isDisabled ? "primary-disabled" : "primary-default"
            },
            thumb: {
                bg: "background-action-default",
                _focus: {
                    boxShadow: "0 0 0 0.1875rem var(--chakra-colors-primary-focus)"
                },
                _disabled: {
                    bg: "background-action-disabled"
                }
            }
        };
    },
    sizes: {
        sm: sharedSizeStyle,
        md: sharedSizeStyle,
        lg: sharedSizeStyle
    }
};
